import { render, staticRenderFns } from "./plan-quote-info.vue?vue&type=template&id=46c8a752&scoped=true&"
import script from "./plan-quote-info.vue?vue&type=script&lang=js&"
export * from "./plan-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./plan-quote-info.vue?vue&type=style&index=0&id=46c8a752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c8a752",
  null
  
)

export default component.exports